export default class DeviceCameraInfo {
    isCameraShared = undefined as boolean | undefined;
    hasAccessedCamera = undefined as boolean | undefined;
}
